import { Box, Divider } from '@mui/material'
import CodeValidationSummary from './CodeValidationSummary'
import CodeDetailsContainer from './CodeDetailsContainer'
import { CodeValidationSummaryProps } from '../../models/Validation'
import { RootState } from '../../store'
import { useSelector } from 'react-redux'

const CodeValidationSummaryContainer = ({
  codeGroups,
}: CodeValidationSummaryProps) => {
  const buildingData = useSelector(
    (state: RootState) => state.construction.convertData,
  )

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'stretch',
          background: 'transparent',
          backgroundColor: '#04002E',
          width: '97%',
          gap: 1,
          px: '7px',
          py: '12px',
          height: '13%',
          borderRadius: '4px',
          '& .MuiCardContent-root:last-child': { paddingBottom: '2px' },
        }}
      >
        <CodeValidationSummary
          title='Overall Validation Score'
          value={'81%'}
          previousYearVariance={23}
        />
        <Divider
          orientation='vertical'
          flexItem
          sx={{ bgcolor: '#312C6F', mx: 0 }}
        />
        <CodeValidationSummary
          title='Discipline Compliance'
          value={'1,403'}
          description='5% Drop from last import'
          previousYearVariance={-5}
        />
        <Divider
          orientation='vertical'
          flexItem
          sx={{ bgcolor: '#312C6F', mx: 0 }}
        />
        <CodeValidationSummary
          title='Status Checks'
          value={'505'}
          description='Stable since last import'
          previousYearVariance={0}
        />
        <Box sx={{ display: 'flex', alignItems: 'center', ml: 1 }}>
          <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M7 10l5 5 5-5'
              stroke='#fff'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        </Box>
      </Box>
      <Box
        sx={{
          position: 'relative',
          mt: 1.5,
          height: '80%',
          padding: '1px 12px',
          background: 'white',
          boxShadow: '0px 3px 5px 0px rgba(47, 47, 47, 0.25)',
          zIndex: 10,
        }}
      >
        <CodeDetailsContainer
          codeGroups={codeGroups}
          buildingData={buildingData}
        />
      </Box>
    </>
  )
}

export default CodeValidationSummaryContainer
